export const categories = [
  {
    id: 'smart-hardware',
    name: '智能硬件',
    description: 'jinman 智能硬件产品线，涵盖智能家居、穿戴设备等前沿科技产品，为您打造智慧生活新体验。',
    icon: 'ri-smartphone-line',
    products: [
      { name: '智能家居中控', desc: '全屋智能一体化控制中心', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20smart%20home%20control%20panel%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-sh-01&orientation=landscape' },
      { name: '智能穿戴手环', desc: '健康监测与运动追踪', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20fitness%20smart%20band%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-sh-02&orientation=landscape' },
      { name: '智能安防系统', desc: '全天候家庭安全守护', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20home%20security%20camera%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-sh-03&orientation=landscape' },
      { name: '智能照明套装', desc: '氛围灯光随心调控', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20smart%20lighting%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-sh-04&orientation=landscape' },
    ],
  },
  {
    id: 'digital-services',
    name: '数字服务',
    description: 'jinman 数字化解决方案，为企业与个人提供高效、安全的云端服务与数据管理平台。',
    icon: 'ri-cloud-line',
    products: [
      { name: '企业云平台', desc: '安全可靠的企业级云服务', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20cloud%20platform%20dashboard%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ds-01&orientation=landscape' },
      { name: '数据分析工具', desc: '智能数据洞察与决策支持', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20data%20analytics%20dashboard%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ds-02&orientation=landscape' },
      { name: '协同办公套件', desc: '高效团队协作一体化方案', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20collaboration%20office%20tool%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ds-03&orientation=landscape' },
      { name: 'AI 智能助手', desc: '人工智能驱动的业务优化', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20AI%20assistant%20digital%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ds-04&orientation=landscape' },
    ],
  },
  {
    id: 'lifestyle',
    name: '生活美学',
    description: 'jinman 生活美学系列，将品质与设计融入日常，让每一个生活细节都散发精致品味。',
    icon: 'ri-home-heart-line',
    products: [
      { name: '香氛系列', desc: '天然精油打造的居家香氛', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20aromatherapy%20diffuser%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ls-01&orientation=landscape' },
      { name: '家居收纳', desc: '简约实用的空间整理方案', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20home%20storage%20organizer%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ls-02&orientation=landscape' },
      { name: '创意文具', desc: '设计感与功能性兼具', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20creative%20stationery%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ls-03&orientation=landscape' },
      { name: '旅行配件', desc: '精致出行的贴心伴侣', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20travel%20accessories%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=600&height=400&seq=cat-ls-04&orientation=landscape' },
    ],
  },
  {
    id: 'enterprise',
    name: '企业方案',
    description: 'jinman 面向企业客户的定制化解决方案，助力企业数字化转型与业务增长。',
    icon: 'ri-building-2-line',
    products: [
      { name: '数字化转型咨询', desc: '量身定制的数字化战略规划', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20enterprise%20consulting%20business%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20office%20style%2C%20no%20text%20or%20logos%2C%20professional%20editorial&width=600&height=400&seq=cat-ep-01&orientation=landscape' },
      { name: 'IT 基础设施', desc: '稳定高效的技术架构搭建', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20server%20infrastructure%20IT%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20style%2C%20no%20text%20or%20logos%2C%20professional%20editorial&width=600&height=400&seq=cat-ep-02&orientation=landscape' },
      { name: '网络安全方案', desc: '全方位企业信息安全防护', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20cybersecurity%20network%20protection%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20style%2C%20no%20text%20or%20logos%2C%20professional%20editorial&width=600&height=400&seq=cat-ep-03&orientation=landscape' },
      { name: '培训与支持', desc: '专业的团队技能提升服务', image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20corporate%20training%20workshop%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20style%2C%20no%20text%20or%20logos%2C%20professional%20editorial&width=600&height=400&seq=cat-ep-04&orientation=landscape' },
    ],
  },
];

export const articles = [
  {
    slug: 'jinman-brand-story',
    title: 'jinman 品牌故事：从初心到卓越的成长之路',
    excerpt: '探索 jinman 品牌的创立初心与发展历程，了解我们如何一步步成为行业信赖之选。',
    category: '品牌故事',
    date: '2025-12-15',
    readTime: '8 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20brand%20story%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20aesthetic%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=1200&height=600&seq=article-01&orientation=landscape',
    content: `
      <h2>品牌起源</h2>
      <p>jinman 品牌诞生于对品质的不懈追求。创始团队怀揣着"让科技温暖生活"的理念，在智能科技与传统人文之间找到了完美的平衡点。从最初的小型工作室，到如今服务数百万用户的品牌，jinman 始终坚守初心。</p>
      <h2>发展历程</h2>
      <p>在过去数年中，jinman 经历了从单一产品线到多元化生态的战略转型。我们不断扩展产品边界，从智能硬件切入，逐步延伸至数字服务、生活美学和企业解决方案四大核心板块。</p>
      <h2>核心理念</h2>
      <p>jinman 相信，真正优秀的产品应该兼具卓越性能与人性化设计。我们坚持用户至上的原则，每一款产品都经过数百次迭代打磨，只为给用户带来最流畅、最贴心的体验。</p>
      <h2>未来展望</h2>
      <p>面向未来，jinman 将继续深耕技术创新，以开放的心态拥抱变化，与全球合作伙伴携手，共同打造更智能、更美好的生活方式。</p>
    `,
  },
  {
    slug: 'jinman-smart-home-guide',
    title: 'jinman 智能家居全攻略：打造未来智慧生活空间',
    excerpt: '从智能中控到场景联动，jinman 为你详解如何构建一个完整的智能家居生态系统。',
    category: '产品指南',
    date: '2026-01-20',
    readTime: '12 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20smart%20home%20living%20room%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20interior%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=1200&height=600&seq=article-02&orientation=landscape',
    content: `
      <h2>智能家居的趋势</h2>
      <p>随着物联网技术的飞速发展，智能家居已经从概念走向现实。jinman 敏锐地捕捉到这一趋势，率先推出了全屋智能解决方案，让科技真正服务于日常生活。</p>
      <h2>核心产品矩阵</h2>
      <p>jinman 智能中控作为整个生态的大脑，能够无缝连接家中的灯光、空调、窗帘、安防等设备。搭配 jinman 智能穿戴手环，还能实现基于用户状态的场景自动切换。</p>
      <h2>场景化体验</h2>
      <p>无论是清晨起床时的"早安模式"、离家后的"安防模式"，还是影音娱乐时的"影院模式"，jinman 都能一键切换，让生活充满仪式感。</p>
      <h2>安装与配置</h2>
      <p>jinman 所有智能设备均支持即插即用，通过 jinman App 即可完成全屋配置。无需专业技术人员，普通用户也能轻松上手。</p>
    `,
  },
  {
    slug: 'jinman-enterprise-digital-transformation',
    title: 'jinman 企业数字化解决方案深度评测',
    excerpt: '深入分析 jinman 为企业客户提供的数字化转型服务，从咨询到落地全流程解读。',
    category: '行业洞察',
    date: '2026-02-10',
    readTime: '10 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20enterprise%20digital%20transformation%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20office%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=1200&height=600&seq=article-03&orientation=landscape',
    content: `
      <h2>数字化转型的挑战</h2>
      <p>在数字经济时代，传统企业面临着前所未有的转型压力。jinman 企业方案正是为应对这一挑战而生，提供从战略规划到技术落地的一站式服务。</p>
      <h2>服务体系</h2>
      <p>jinman 的数字化转型咨询团队由经验丰富的行业专家组成，能够深入理解不同行业的业务逻辑，量身定制转型路径。结合 jinman 云平台和 AI 工具，帮助企业快速实现数据驱动决策。</p>
      <h2>成功案例</h2>
      <p>某大型制造企业通过 jinman 方案，在生产流程中引入智能监控和预测性维护，设备故障率降低 45%，生产效率提升 30%。另一家零售连锁企业借助 jinman 的数据分析工具，实现了精准营销，销售额同比增长 25%。</p>
      <h2>安全与合规</h2>
      <p>jinman 始终将数据安全放在首位，所有企业方案均符合国际安全标准，确保客户数据的机密性、完整性和可用性。</p>
    `,
  },
  {
    slug: 'jinman-user-experience-design',
    title: '揭秘 jinman 产品设计哲学：用户体验至上的背后逻辑',
    excerpt: 'jinman 设计团队分享产品开发背后的思考：如何将复杂技术转化为简单优雅的用户体验。',
    category: '设计理念',
    date: '2026-03-05',
    readTime: '7 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20UX%20design%20workshop%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20studio%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=1200&height=600&seq=article-04&orientation=landscape',
    content: `
      <h2>设计即沟通</h2>
      <p>在 jinman 看来，产品设计本质上是一种与用户的无声沟通。每一个按钮的位置、每一处色彩的搭配、每一次交互动画，都在向用户传递品牌的温度与态度。</p>
      <h2>简约不简单</h2>
      <p>jinman 坚持极简设计风格，但这并不意味着功能的妥协。相反，我们在背后投入了大量精力，将复杂的算法和逻辑隐藏在简洁的界面之下，让用户感受到的是"自然而然"的操作体验。</p>
      <h2>用户研究驱动</h2>
      <p>每一款 jinman 产品在立项之初，都会进行深度的用户调研。我们通过访谈、观察、数据分析等多种方式，真正理解用户的需求和痛点，从而设计出真正有价值的解决方案。</p>
      <h2>持续迭代</h2>
      <p>产品上线不是终点，而是新的起点。jinman 建立了完善的用户反馈机制，每月进行功能迭代，确保产品始终走在用户需求的前面。</p>
    `,
  },
  {
    slug: 'jinman-2026-trends',
    title: '2026 年科技趋势展望：jinman 眼中的下一个风口',
    excerpt: 'jinman 研究院发布年度趋势报告，解读 AI、IoT、绿色科技等领域的发展方向。',
    category: '行业洞察',
    date: '2026-04-18',
    readTime: '15 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20future%20technology%20trends%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20abstract%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=1200&height=600&seq=article-05&orientation=landscape',
    content: `
      <h2>AI 普惠化</h2>
      <p>2026 年，人工智能将进一步从实验室走向大众。jinman 认为，AI 不再是少数科技巨头的专属，而是将融入日常生活的方方面面。我们的 AI 智能助手正是这一趋势的体现。</p>
      <h2>绿色科技崛起</h2>
      <p>可持续发展已成为全球共识。jinman 在产品设计中全面贯彻绿色理念，从材料选择到能源管理，每一个环节都力求环保低碳。</p>
      <h2>虚实融合</h2>
      <p>增强现实与虚拟现实技术正在模糊物理世界与数字世界的边界。jinman 在这一领域持续投入研发，探索虚实融合的更多可能性。</p>
      <h2>隐私优先</h2>
      <p>在数据驱动的时代，用户隐私保护比以往任何时候都更重要。jinman 承诺所有产品均遵循隐私优先的设计原则，让用户在享受科技便利的同时，不必担心个人信息泄露。</p>
    `,
  },
  {
    slug: 'jinman-customer-success-stories',
    title: 'jinman 用户故事：真实口碑见证品牌力量',
    excerpt: '来自不同行业的 jinman 用户分享他们的真实使用体验，看 jinman 如何改变他们的工作和生活。',
    category: '用户故事',
    date: '2026-05-22',
    readTime: '9 分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20customer%20testimonial%20happy%20people%20photography%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20terracotta%20background%2C%20elegant%20modern%20lifestyle%2C%20no%20text%20or%20logos%2C%20professional%20editorial%20style&width=1200&height=600&seq=article-06&orientation=landscape',
    content: `
      <h2>创业者的智能办公室</h2>
      <p>张先生是一位科技创业者，他使用 jinman 智能家居中控打造了全智能化的办公环境。"从灯光到会议室预约，一切都是自动化的，客户来访时都会被这种科技感震撼。"</p>
      <h2>家庭主妇的得力助手</h2>
      <p>李女士是两个孩子的母亲，jinman 智能安防和照明系统让她的家庭管理变得更加轻松。"以前总是担心孩子在家是否安全，现在通过手机就能随时查看家中情况，真的安心很多。"</p>
      <h2>企业高管的效率革命</h2>
      <p>王总监所在的制造企业引入了 jinman 企业方案后，整个生产流程实现了数字化管理。"数据可视化让决策变得有据可依，团队协作效率大幅提升。"</p>
      <h2>设计师的灵感空间</h2>
      <p>陈设计师是 jinman 香氛系列和创意文具的忠实用户。"jinman 的产品不仅是工具，更是一种生活态度的表达。它们让我的工作空间充满灵感。"</p>
    `,
  },
];

export const testimonials = [
  {
    name: '张伟',
    role: '科技创业者',
    avatar: 'Z',
    content: 'jinman 的智能家居产品彻底改变了我对智能生活的认知。从安装到使用，每一个环节都体现了品牌的用心和专业。',
    rating: 5,
  },
  {
    name: '李娜',
    role: '家庭用户',
    avatar: 'L',
    content: '作为一个不太懂科技的家庭主妇，jinman 的产品上手非常简单。客服团队也很耐心，遇到问题总能第一时间解决。',
    rating: 5,
  },
  {
    name: '王建国',
    role: '企业CTO',
    avatar: 'W',
    content: '我们公司采购了 jinman 的企业解决方案，从部署到培训都非常专业。数据安全方面做得尤其出色，完全符合我们的合规要求。',
    rating: 5,
  },
  {
    name: '陈思雨',
    role: '独立设计师',
    avatar: 'C',
    content: 'jinman 的生活美学系列产品是我工作室的标配。简约的设计风格与卓越的品质完美融合，客户来访都赞不绝口。',
    rating: 4,
  },
  {
    name: '刘强',
    role: '零售店主',
    avatar: 'L',
    content: '使用 jinman 数据分析工具后，我们店铺的运营效率提升了不止一个档次。库存管理和客户分析都变得一目了然。',
    rating: 5,
  },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '品质保证',
    desc: '每一款 jinman 产品都经过严格质检，符合国际标准，让您用得安心。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '创新驱动',
    desc: 'jinman 持续投入研发，以领先技术打造卓越产品，引领行业发展方向。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    desc: '7×24 小时专业客服团队，随时为您解决使用中遇到的任何问题。',
  },
  {
    icon: 'ri-global-line',
    title: '全球视野',
    desc: 'jinman 产品远销全球 30+ 国家和地区，获得数百万用户的信赖与好评。',
  },
];

export const stats = [
  { value: '500万+', label: '全球用户' },
  { value: '30+', label: '覆盖国家' },
  { value: '99.7%', label: '客户满意度' },
  { value: '1200+', label: '企业客户' },
];